module.exports = __webpack_public_path__ + "static/assets/b21383c10bc9159629dcfa1dfd5680cc.svg";